import api from './api';

export const dashboardService = {
  // Pobierz przegląd dashboardu
  getOverview: async () => {
    const response = await api.get('/dashboard/overview');
    return response.data;
  },

  // Pobierz szybkie akcje
  getQuickActions: async () => {
    const response = await api.get('/dashboard/quick-actions');
    return response.data;
  },

  // Pobierz powiadomienia
  getNotifications: async () => {
    const response = await api.get('/dashboard/notifications');
    return response.data;
  },

  // Pobierz log aktywności
  getActivityLog: async (page = 1, limit = 20) => {
    const response = await api.get(`/dashboard/activity-log?page=${page}&limit=${limit}`);
    return response.data;
  },

  // Oznacz powiadomienie jako przeczytane
  markNotificationAsRead: async (notificationId) => {
    const response = await api.put(`/dashboard/notifications/${notificationId}/read`);
    return response.data;
  },

  // Oznacz wszystkie powiadomienia jako przeczytane
  markAllNotificationsAsRead: async () => {
    const response = await api.put('/dashboard/notifications/read-all');
    return response.data;
  },

  // Ukryj powiadomienie systemowe
  dismissNotification: async (notificationId) => {
    const response = await api.post(`/dashboard/notifications/${notificationId}/dismiss`);
    return response.data;
  },

  // Pobierz ogłoszenia dla dashboardu
  getAnnouncements: async () => {
    const response = await api.get('/dashboard/announcements');
    return response.data;
  },

  // Pobierz udostępnienia bloków
  getBlockShares: async (blockId) => {
    const url = blockId ? `/dashboard/block-shares?blockId=${blockId}` : '/dashboard/block-shares';
    const response = await api.get(url);
    return response.data;
  },

  // Udostępnij blok użytkownikom (może być wielu użytkowników)
  shareBlock: async (blockId, userIds) => {
    const response = await api.post('/dashboard/block-shares', { blockId, userIds });
    return response.data;
  },

  // Usuń udostępnienie bloku (pojedynczy użytkownik lub wszyscy jeśli userId nie podany)
  unshareBlock: async (blockId, userId = null) => {
    const url = userId 
      ? `/dashboard/block-shares?blockId=${blockId}&userId=${userId}`
      : `/dashboard/block-shares?blockId=${blockId}`;
    const response = await api.delete(url);
    return response.data;
  }
};
